
import { Injectable, Injector, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { mergeMap, switchMap, catchError } from 'rxjs/operators';

import { AuthService } from '../services/auth/auth.service';
import { ConfigurationService } from '../services/Common/configuration.service';
import { environment } from '@env/environment';
import { DBkeys } from '../services/db-Keys';
import { NotificationService } from '../services';
import { AlertService } from '../services/Common/alert.service';
import { AuthorizeService } from '../services/auth/authorize.service';


@Injectable()
export class EndpointFactory {

  static readonly apiVersion: string = '1';
  private readonly _loginUrl: string = '/connect/token';
  private csrfToken = "";
  private get loginUrl() { return this.configurations.baseUrl + this._loginUrl; }

  private taskPauser: Subject<any>;
  private isRefreshingLogin: boolean;

  private _authService: AuthService;
  private _authorizeService: AuthorizeService;
  private _alertService: AlertService;

  private getCookie(name: string): string | null {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  private get authService() {
    if (!this._authService) {
      this._authService = this.injector.get(AuthService);
    }
    let csrfToken = this.getCookie('X-CSRF-TOKEN');
    if (csrfToken == null) {
      csrfToken = "";
    }

    this.csrfToken = csrfToken;

    return this._authService;
  }
  private get authorizeService() {
    if (!this._authorizeService) {
      this._authorizeService = this.injector.get(AuthorizeService);
    }
    return this._authorizeService;
  }
  private get alertService() {
    if (!this._alertService) {
      this._alertService = this.injector.get(AlertService);
    }
    return this._alertService;
  }

  constructor(protected http: HttpClient, protected configurations: ConfigurationService, private injector: Injector) {
    this.getAuthHeader_devextreme = this.getAuthHeader_devextreme.bind(this);

  }


  // getLoginEndpoint<T>(userName: string, password: string, recaptcha?:string): Observable<T> {

  //   const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

  //   const params = new HttpParams()
  //     .append('username', userName)
  //     .append('password', password)
  //     .append('client_id', environment.clientId)
  //     .append('grant_type', 'password')
  //     .append('scope', 'openid email phone profile offline_access roles smartapp_api')
  //     .append('recaptcha', recaptcha);


  //   return this.http.post<T>(this.loginUrl, params, { headers: header });
  // }


  // getRefreshLoginEndpoint<T>(): Observable<T> {

  //   const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

  //   const params = new HttpParams()
  //     .append('refresh_token', this.authService.refreshToken)
  //     .append('client_id', environment.clientId)
  //     .append('grant_type', 'refresh_token')
  //     .append('scope', 'openid email phone profile offline_access roles');


  //   return this.http.post<T>(this.loginUrl, params, { headers: header }).pipe<T>(
  //     catchError(error => {
  //       return this.handleError(error, () => this.getRefreshLoginEndpoint());
  //     }));
  // }

  /* helper methods */
  protected getPdfDownloadHeaders(): any {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Content-Type': 'application/pdf',
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion,
      'x_client_id': environment.clientKey,
      'responseType': 'blob',
      'BrowserInfo': this.authorizeService.browserInfo(),
      'X-CSRF-TOKEN': this.csrfToken
    });
    return { headers: headers, 'observe': 'response', responseType: 'blob' };
  }
  protected getRequestHeaders(apiVersion?: string): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    if (this.csrfToken == null) {
      this.csrfToken = this.getCookie("X-CSRF-TOKEN");
    }
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Content-Type': 'application/json',
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion,
      'x_client_id': environment.clientKey,
      'x-api-version': (apiVersion == "" || apiVersion == undefined) ? "1.0" : apiVersion,
      'BrowserInfo': this.authorizeService.browserInfo(),
      'X-CSRF-TOKEN': this.csrfToken
    });

    return { headers: headers };
  }
  protected getDocRequestHeaders(apiVersion?: string): { headers: HttpHeaders | { [header: string]: string | string[]; } } {
    if (this.csrfToken == null) {
      this.csrfToken = this.getCookie("X-CSRF-TOKEN");
    }
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion,
      'x_client_id': environment.clientKey,
      'x-api-version': (apiVersion == "" || apiVersion == undefined) ? "1.0" : apiVersion,
      'BrowserInfo': this.authorizeService.browserInfo(),
      'X-CSRF-TOKEN': this.csrfToken
    });

    return { headers: headers };
  }


  protected getZipDownloadHeaders(): any {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Content-Type': 'application/zip',
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion,
      'responseType': 'blob',
      'BrowserInfo': this.authorizeService.browserInfo(),
      'X-CSRF-TOKEN': this.csrfToken
    });

    return { headers: headers, 'observe': 'response', responseType: 'blob' };
  }
  protected getExcelDownloadHeaders(): any {
    const headers = new HttpHeaders({
      'Authorization': 'Bearer ' + this.authService.accessToken,
      'Content-Type': 'application/vnd.ms-excel.template.macroEnabled.12',
      'Accept': `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`,
      'App-Version': ConfigurationService.appVersion,
      'x_client_id': environment.clientKey,
      'responseType': 'blob',
      'BrowserInfo': this.authorizeService.browserInfo(),
      'X-CSRF-TOKEN': this.csrfToken
    });

    return { headers: headers, 'observe': 'response', responseType: 'blob' as 'json' };
  }
  //***Workaround*** */ The global getheader method is not used because caling other method inside onBeforeSend function of AspNetData.createStore
  protected getAuthHeader_devextreme(method, ajaxOptions = { headers: {} }) {
    // var tokenx = _this.authorizeService.getAccessToken();
    if (!this.csrfToken) {
      this.csrfToken = this.getCookie("X-CSRF-TOKEN");
    }

    if (sessionStorage.getItem(DBkeys.ACCESS_TOKEN)) {
      var token = sessionStorage.getItem(DBkeys.ACCESS_TOKEN);
      var bearertoken = "Bearer " + JSON.parse(token);
      var apiVersion = ConfigurationService.apiVersion;
      ajaxOptions.headers = { Authorization: bearertoken, 'X-CSRF-TOKEN': this.csrfToken, 'x_client_id': environment.clientKey, 'x-api-version': (apiVersion == "" || apiVersion == undefined) ? "1.0" : apiVersion };
    }
  }
  protected handleError_devextreme(error) {

    if (error.message == 'Unauthorized' || error.status == 401) {
      //TODO: notify popup session timeout
      //redirect use to login page
      //this.authService.refreshLogin();
      // return this.authService.refreshLogin().pipe(
      //   mergeMap(data => {
      //     this.isRefreshingLogin = false;
      //     this.resumeTasks(true);

      //     //return true;
      //   }),
      //   catchError(refreshLoginError => {
      //     this.isRefreshingLogin = false;
      //     this.resumeTasks(false);

      //     if (refreshLoginError.status == 401 || (refreshLoginError.url && refreshLoginError.url.toLowerCase().includes(this.loginUrl.toLowerCase()))) {
      //       this.authService.reLogin();
      //       return throwError('session expired');
      //     } else {
      //       return throwError(refreshLoginError || 'server error');
      //     }
      //   }));
      //this.authService.logout();
      //alert('session timed out, Please login again');
      console.log('Session timed out - relogging in...')
      this.authService.redirectForLogin();
      // this.alertService.showDialog('session timed out, Please login again');
      // this.alertService.showStickyMessage('session timed out, Please login again');
    }
    if (error.message == "[object XMLHttpRequest]") {
      //this.authService.refreshLogin();
      this.authorizeService.refreshLogin();
      //alert('session timed out, Please login again');
      //this.authService.redirectForLogin();
    }
  }

  protected handleError(error, continuation: () => Observable<any>) {

    if (error.status == 0) //network error
    {
      return this.pauseTask(continuation);
    }
    if (error.status == 401) {
      if (this.isRefreshingLogin) {
        return this.pauseTask(continuation);
      }

      this.isRefreshingLogin = true;

      return this.authService.refreshLogin().pipe(
        mergeMap(data => {
          this.isRefreshingLogin = false;
          this.resumeTasks(true);

          return continuation();
        }),
        catchError(refreshLoginError => {
          this.isRefreshingLogin = false;
          this.resumeTasks(false);

          if (refreshLoginError.status == 401 || (refreshLoginError.url && refreshLoginError.url.toLowerCase().includes(this.loginUrl.toLowerCase()))) {
            this.authService.reLogin();
            return throwError('session expired');
          } else {
            return throwError(refreshLoginError || 'server error');
          }
        }));
    }

    if (error.url && error.url.toLowerCase().includes(this.loginUrl.toLowerCase())) {
      this.authService.reLogin();

      return throwError((error.error && error.error.error_description) ? `session expired (${error.error.error_description})` : 'session expired');
    } else {
      return throwError(error);
    }
  }



  private pauseTask(continuation: () => Observable<any>) {
    if (!this.taskPauser) {
      this.taskPauser = new Subject();
    }

    return this.taskPauser.pipe(switchMap(continueOp => {
      return continueOp ? continuation() : throwError('session expired');
    }));
  }


  private resumeTasks(continueOp: boolean) {
    setTimeout(() => {
      if (this.taskPauser) {
        this.taskPauser.next(continueOp);
        this.taskPauser.complete();
        this.taskPauser = null;
      }
    });
  }
}
